<template>
  <v-container>
    <v-row>
      <v-col>
        <page-title
          title="Módulos"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="(moduleRoute, index) in moduleList"
        :key="`moduleRoute-${index}`"
        cols="3"
      >
        <v-card
          class="py-2 d-flex align-center"
          height="100px"
          :to="{ name: moduleRoute.meta.module.subModuleListRouteName }"
        >
          <div class="d-flex flex-no-wrap align-center px-5">
            <v-avatar
              size="52"
              tile
            >
              <v-img :src="moduleRoute.meta.module.moduleLogo" />
            </v-avatar>
            <div>
              <v-card-title class="h2Header bold secondary300">
                {{
                  moduleRoute.meta.module.moduleName
                }}
              </v-card-title>

              <v-card-subtitle class="h3Header secondary200">
                Acessar
              </v-card-subtitle>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PageTitle from 'Arch/template/PageTitle.vue';

export default {
  name: 'ModulesList',
  components: { PageTitle },
  computed: {
    moduleList() {
      return this.$router.options.routes[0].children.filter((item) => this.isModule(item));
    },
  },
  methods: {
    isModule(item) {
      return !!item.meta && item.meta.module && item.meta.module.moduleName !== null;
    },
  },
};
</script>
